document.addEventListener('alpine:init', () => {
    Alpine.data('postFilter', (blockId, perPage) => ({
        posts: [],
        filters: { category: '', search: '' },
        page: 1,
        total: 0,
        canLoadMore: false,
        loading: false,
  
        init() {
            const contentEl = document.getElementById('Content_' + blockId);
            if (!contentEl) return;
  
            this.total = parseInt(contentEl.dataset.totalPosts, 10) || 0;
            this.perPage = perPage;
  
            this.posts = Array.from(contentEl.children).map(child => ({ html: child.outerHTML }));
  
            this.canLoadMore = this.posts.length < this.total;
  
            this.renderPosts();
        },
  
        applyFilters() {
            this.page = 1;
            this.posts = [];
            this.fetchPosts(true);
        },
  
        loadMore() {
            if (!this.canLoadMore || this.loading) return;
            this.page++;
            this.fetchPosts();
        },
  
        fetchPosts(reset = false) {
            this.loading = true;
  
            const params = new URLSearchParams({
                pagenr: this.page,
                category: this.filters.category,
                search: this.filters.search,
                blockId: blockId
            });
  
            fetch(`${window.location.pathname}?${params.toString()}`)
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const contentEl = doc.getElementById('Content_' + blockId);
  
                    if (contentEl) {
                        const newPosts = Array.from(contentEl.children).map(child => ({ html: child.outerHTML }));
  
                        if (reset) this.posts = [];
                        this.posts.push(...newPosts);
  
                        this.total = parseInt(contentEl.dataset.totalPosts, 10) || this.total;
                        this.canLoadMore = this.posts.length < this.total;
  
                        this.renderPosts();
                    } else {
                        this.canLoadMore = false;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
  
        renderPosts() {
            const container = document.getElementById('Content_' + blockId);
            if (!container) return;
  
            container.innerHTML = '';
            this.posts.forEach(post => {
                const wrapper = document.createElement('div');
                wrapper.innerHTML = post.html;
                container.appendChild(wrapper.firstElementChild);
            });
        }
    }));
  });
  